module.exports = __webpack_public_path__ + "static/pakmaya-organik-trafik-3de62d71292e206aeb6db37a54bc9cb9.png";